import React, { Fragment ,useState, useEffect} from "react";
import PropTypes from "prop-types";
import Pcards from "./Pcards";
import { Navigate} from 'react-router-dom';
import { Box } from "@mui/material";

function Fav(props) {
  const { data} = props;
  const [favdata, setFavdata]=useState([])
  const [firts, setfirts]=useState(true)


    if(localStorage.getItem('fav')){
     if(data.length> 0 && firts)
      {
        let fav_id = localStorage.getItem('fav').split(',')
        console.log(fav_id)
        console.log(data)
        setFavdata( data.filter(el => fav_id.indexOf(el.id.toString()) > -1))
        console.log(favdata)
        setfirts(false)
      }
    }
    else{
       
      return (
        <Fragment>
          <Navigate to='/'></Navigate>
        </Fragment>
      );
    } 
  

  return (
    <Fragment>
      <Box mt='20vh'>
      <Pcards data={favdata} name='Teidän Suosikki Tuotteet' ismenu={true} types={[]}/>
      </Box>
    </Fragment>
  );
}

Fav.propTypes = {
  selectHome: PropTypes.func.isRequired
};

export default Fav;
